// extracted by mini-css-extract-plugin
module.exports = {"prefix":"styles_prefix__Hqp9_","postfix":"styles_postfix__lAfi2"};